<template>
  <div class="all">
    <Header :Share="Share" :isShelves="isShelves" :pageTitle="text" :isDictionary="false" />
    <div class="content-box">
      <h3>{{text}}</h3>
      <p style="margin: 10px 0;">[{{PyText}}]</p>
      <p v-for="xml,index in XMLabstract" :key="'xml-'+index">
        <span>{{xml._}}</span>
        <span v-for="example,index in xml.example" :key="'example'+index">{{example}}</span>
        <span v-for="xml1,index in xml.citation" :key="'xml1-'+index">
          <span v-if="xml1.author">{{xml1.author[0]}}</span>
          <span v-for="xml2,index in xml1.fullbookname" :key="'xml2-'+index">
            <span v-for="xml3,index in xml2.bookname" :key="'xml3-'+index">
                &nbsp;<span>《&nbsp;{{xml3}}&nbsp;》</span>
            </span>
            <span v-for="xml4,index in xml1.content" :key="'xml4-'+index">
                <span>{{xml4}}</span>
            </span>
          </span>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import Header from "@/views/mobileView/detail/components/Header.vue";
const { pinyin } = require('pinyin-pro');
const { parseString } = require('xml2js');
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Header,
  },
  data() {
    return {
      Share: {},
      isShelves: false,
      text: '',
      PyText: '',
      XMLabstract: [],
    };
  },
  created() {
    this.text = this.$route.params.searchStr
    this.PyText = pinyin(this.text)
    this.getContent({word: this.text})
  },
  methods: {
    async getContent(word) {
      const resp = await this.$apis.searchServe.getDictionary(word);
      if(resp.data.content[0]){
        parseString(resp.data.content[0].docXml,(err, content)=>{
          let XMLObj = JSON.parse(JSON.stringify(content, null, 4))
          if(XMLObj.entry.definition[0].section[0].sense){
            this.XMLabstract = XMLObj.entry.definition[0].section[0].sense
          }
        })
      }
    },
  }
};
</script>

<style lang='scss' scoped>

.all {
  padding-bottom: 100px;
  .content-box {
    padding: 90px 15px 0;
  }
}
</style>